export default "__VITE_ASSET__DtfDEpyQ__"